var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_code"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "code"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift_product_code"]
                            },
                            model: {
                              value: _vm.model.code,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "code", $$v)
                              },
                              expression: "model.code"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_name"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "name"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift_product_name"]
                            },
                            model: {
                              value: _vm.model.name,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "name", $$v)
                              },
                              expression: "model.name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_user_app"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "app"
                          }
                        },
                        [
                          _c("a-select", {
                            attrs: {
                              options: _vm.appList,
                              disabled: _vm.isDisabled
                            },
                            on: { change: _vm.handlerApp },
                            model: {
                              value: _vm.model.app,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "app", $$v)
                              },
                              expression: "model.app"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_vendor"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "supplier"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              on: { change: _vm.handlerChange },
                              model: {
                                value: _vm.model.supplier,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "supplier", $$v)
                                },
                                expression: "model.supplier"
                              }
                            },
                            _vm._l(_vm.vendorMap, function(v, k) {
                              return _c(
                                "a-select-option",
                                { key: k, attrs: { value: k, label: v } },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(v) +
                                      "\n                "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticStyle: { "margin-left": "20px" },
                          attrs: {
                            label: _vm.language["gift_up_down"],
                            labelCol: _vm.labelCol3
                          }
                        },
                        [
                          _c("j-switch", {
                            on: { change: _vm.changeSwitch },
                            model: {
                              value: _vm.model.status,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "status", $$v)
                              },
                              expression: "model.status"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_thumbnail"],
                            labelCol: _vm.labelCol2,
                            wrapperCol: _vm.wrapperCol2,
                            prop: "thumbnail"
                          }
                        },
                        [
                          _c("j-image-upload", {
                            staticClass: "avatar-uploader",
                            attrs: {
                              text: _vm.language["common.uploadButton"],
                              "upload-source": _vm.uploadSource,
                              isMultiple: false,
                              "biz-path": _vm.uploadSource,
                              maxSize: 200,
                              "customer-before-upload": _vm.beforeUpload,
                              disabled: _vm.disableSubmit
                            },
                            model: {
                              value: _vm.model.thumbnail,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "thumbnail", $$v)
                              },
                              expression: "model.thumbnail"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_img"],
                            labelCol: _vm.labelCol2,
                            wrapperCol: _vm.wrapperCol2,
                            prop: "images"
                          }
                        },
                        [
                          _c("j-image-upload", {
                            staticClass: "avatar-uploader",
                            attrs: {
                              text: _vm.language["common.uploadButton"],
                              "upload-source": _vm.uploadSource,
                              isMultiple: true,
                              "biz-path": _vm.uploadSource,
                              maxSize: 200,
                              "customer-before-upload": _vm.beforeUpload,
                              disabled: _vm.disableSubmit
                            },
                            model: {
                              value: _vm.model.images,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "images", $$v)
                              },
                              expression: "model.images"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_tag"],
                            labelCol: _vm.labelCol2,
                            wrapperCol: _vm.wrapperCol2,
                            prop: "value"
                          }
                        },
                        _vm._l(_vm.tagList, function(item) {
                          return _c(
                            "div",
                            [
                              _c("span", [_vm._v(_vm._s(item.title))]),
                              _c("j-checkbox", {
                                staticStyle: { "margin-left": "20px" },
                                attrs: { options: item.tags },
                                on: {
                                  change: function($event) {
                                    return _vm.handleCheckBox(
                                      item.title,
                                      item.value
                                    )
                                  }
                                },
                                model: {
                                  value: item.value,
                                  callback: function($$v) {
                                    _vm.$set(item, "value", $$v)
                                  },
                                  expression: "item.value"
                                }
                              })
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "卡路里",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "calories"
                          }
                        },
                        [
                          _c("a-input", {
                            staticStyle: {
                              width: "90%",
                              "margin-right": "5px"
                            },
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] + "卡路里"
                            },
                            model: {
                              value: _vm.model.calories,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "calories", $$v)
                              },
                              expression: "model.calories"
                            }
                          }),
                          _c("span", [_vm._v("cal")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "市場售價",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "marketPrice"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] + "市場售價"
                            },
                            model: {
                              value: _vm.model.marketPrice,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "marketPrice", $$v)
                              },
                              expression: "model.marketPrice"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "賞味期限",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "shelfLife"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] + "賞味期限"
                            },
                            model: {
                              value: _vm.model.shelfLife,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "shelfLife", $$v)
                              },
                              expression: "model.shelfLife"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "內容物",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "detail"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] + "內容物"
                            },
                            model: {
                              value: _vm.model.detail,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "detail", $$v)
                              },
                              expression: "model.detail"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.notVirtualFlag
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["gift_product_ingredient"],
                                labelCol: _vm.labelCol2,
                                wrapperCol: _vm.wrapperCol2,
                                prop: "ingredient"
                              }
                            },
                            [
                              _c("a-textarea", {
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseInput"] +
                                    _vm.language["gift_product_ingredient"],
                                  "auto-size": { minRows: 5, maxRows: 8 }
                                },
                                model: {
                                  value: _vm.model.ingredient,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "ingredient", $$v)
                                  },
                                  expression: "model.ingredient"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c("gift-product-select-modal", {
            ref: "modalSelect",
            on: { ok: _vm.modalSelect }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }